function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n, { changeLocale } from '@/utils/i18n';
import SvgIcon from '@/components/svg-icon-nc';
import { createDesigner } from '../designer';
import VFormRender from '@/components/form-render/index';
import { addWindowResizeHandler, deepClone, getAllContainerWidgets, getAllFieldWidgets, getQueryParam, traverseAllWidgets, generateId } from '@/utils/util';
import FieldPanel from './FieldPanel';
import VFormWidget from './VFormWidget';
import SettingPanel from './SettingPanel';
import oaDialog from '@/components/form-common/dialog-form';
import { changeDashboard } from '@/api/chart';
export default {
  name: 'VFormDesigner',
  componentName: 'VFormDesigner',
  mixins: [i18n],
  components: {
    SvgIcon: SvgIcon,
    FieldPanel: FieldPanel,
    VFormWidget: VFormWidget,
    SettingPanel: SettingPanel,
    VFormRender: VFormRender,
    oaDialog: oaDialog
  },
  props: {
    fieldListApi: {
      type: Object,
      default: null
    },
    fieldListData: {
      type: Object,
      default: null
    },
    bannedWidgets: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    designerConfig: {
      type: Object,
      default: function _default() {
        return {
          languageMenu: !0,
          externalLink: !0,
          formTemplates: !0,
          componentLib: !0,
          chartLib: !1,
          metadataLib: !1,
          layoutTypeButton: !0,
          eventCollapse: !0,
          widgetNameReadonly: !1,
          clearDesignerButton: !0,
          previewFormButton: !0,
          importJsonButton: !0,
          exportJsonButton: !0,
          exportCodeButton: !0,
          generateSFCButton: !0,
          logoHeader: !0,
          toolbarMaxWidth: 450,
          toolbarMinWidth: 300,
          productName: '',
          productTitle: '',
          presetCssCode: '',
          languageName: 'zh-CN',
          resetFormJson: !1
        };
      }
    },
    globalDsv: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    formTemplates: {
      type: Array,
      default: null
    },
    testOptionData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      vFormVersion: '1.0.0',
      curLangName: '',
      curLocale: '',
      vsCodeFlag: !1,
      showPreviewDialogFlag: !1,
      caseName: '',
      docUrl: '',
      gitUrl: '',
      chatUrl: '',
      subScribeUrl: '',
      designer: createDesigner(this),
      fieldList: [],
      subFormList: [],
      optionData: this.testOptionData,
      externalComponents: {},
      leftAsideVisible: !0,
      rightAsideVisible: !0,
      widgetPanelKey: 'widgetPanel' + generateId(),
      scrollerHeight: 0,
      fromData: {
        width: '600px',
        title: '编辑名称',
        btnText: '确定',
        labelWidth: '100px',
        type: ''
      },
      formConfig: [{
        type: 'input',
        label: '图表名称：',
        placeholder: '请输入图表名称',
        key: 'name',
        options: []
      }],
      id: 0,
      formRules: {
        name: [{
          required: true,
          message: '请输入图表名称',
          trigger: 'blur'
        }]
      },
      formDataInit: {
        name: ''
      }
    };
  },
  provide: function provide() {
    var _this = this;
    return {
      getServerFieldList: function getServerFieldList() {
        return _this.fieldList;
      },
      getServerSubFormList: function getServerSubFormList() {
        return _this.subFormList;
      },
      getDesignerConfig: function getDesignerConfig() {
        return _this.designerConfig;
      },
      getBannedWidgets: function getBannedWidgets() {
        return _this.bannedWidgets;
      },
      getTestOptionData: function getTestOptionData() {
        return _this.optionData;
      },
      previewState: false
    };
  },
  computed: {
    vfProductName: function vfProductName() {
      return this.designerConfig && this.designerConfig.productName || 'VForm Pro';
    },
    vfProductTitle: function vfProductTitle() {
      return this.designerConfig && this.designerConfig.productTitle || this.i18nt('application.productTitle');
    }
  },
  created: function created() {
    var _this2 = this;
    this.designer.initDesigner(!!this.designerConfig.resetFormJson), this.vsCodeFlag = getQueryParam('vscode') == 1, this.caseName = getQueryParam('case'), this.designer.handleEvent('canvas-select-field', function (o) {
      _this2.$emit('field-widget-used', o);
    }), this.designer.handleEvent('canvas-remove-field', function (o) {
      _this2.$emit('field-widget-removed', o);
    }), this.designer.handleEvent('form-json-imported', function () {
      _this2.$emit('form-json-updated', 'form-json-imported');
    }), this.designer.handleEvent('canvas-undo', function () {
      _this2.$emit('form-json-updated', 'canvas-undo');
    }), this.designer.handleEvent('canvas-redo', function () {
      _this2.$emit('form-json-updated', 'canvas-redo');
    }), this.designer.handleEvent('canvas-remove-container', function () {
      _this2.$emit('form-json-updated', 'canvas-remove-container');
    });
  },
  mounted: function mounted() {
    var _this3 = this;
    this.initLocale();
    this.initFormTemplates();
    this.loadCase();
    this.initServerFields();
    this.scrollerHeight = window.innerHeight - 60 + 'px';
    addWindowResizeHandler(function () {
      _this3.$nextTick(function () {
        _this3.scrollerHeight = window.innerHeight - 60 + 'px';
      });
    });
  },
  methods: {
    submit: function submit(data) {
      var _this4 = this;
      changeDashboard(this.id, data).then(function (res) {
        _this4.$emit('changeTitle', data.name);
        _this4.$refs.oaDialog.handleClose();
      });
    },
    // 编辑
    editFn: function editFn(row) {
      this.id = row.id;
      this.formDataInit.name = row.name;
      this.$refs.oaDialog.openBox();
    },
    testEEH: function testEEH(o, e) {},
    showLink: function showLink(o) {
      return this.designerConfig[o] === void 0 ? !0 : !!this.designerConfig[o];
    },
    openHome: function openHome() {
      if (this.vsCodeFlag) {
        var o = {
          cmd: 'openUrl',
          data: {
            url: 'https://www.vform666.com/'
          }
        };
        window.parent.postMessage(o, '*');
      }
    },
    openUrl: function openUrl(o, e) {
      if (this.vsCodeFlag) {
        var n = {
          cmd: 'openUrl',
          data: {
            url: e
          }
        };
        window.parent.postMessage(n, '*');
      } else {
        var _n = o.currentTarget;
        _n.href = e;
      }
    },
    loadCase: function loadCase() {
      var _this5 = this;
      !this.caseName || axios.get(MOCK_CASE_URL + this.caseName + '.txt').then(function (o) {
        if (o.data.code) {
          _this5.$message.error(_this5.i18nt('designer.hint.sampleLoadedFail'));
          return;
        }
        _this5.setFormJson(o.data), _this5.$message.success(_this5.i18nt('designer.hint.sampleLoadedSuccess'));
      }).catch(function (o) {
        _this5.$message.error(_this5.i18nt('designer.hint.sampleLoadedFail') + ':' + o);
      });
    },
    initLocale: function initLocale() {
      ;
      this.curLocale = localStorage.getItem('form_cache'), this.vsCodeFlag ? this.curLocale = this.curLocale || 'en-US' : this.curLocale = this.curLocale || 'zh-CN', this.curLangName = this.i18nt('application.' + this.curLocale), this.changeLanguage(this.curLocale);
    },
    initFormTemplates: function initFormTemplates() {
      this.formTemplates && (clearFormTemplates(), this.formTemplates.length > 0 && this.formTemplates.forEach(function (o) {
        addFormTemplate(o);
      }));
    },
    loadFieldListFromServer: function loadFieldListFromServer() {
      var _this6 = this;
      if (!this.fieldListApi) return;
      var o = this.fieldListApi.headers || {};
      axios.get(this.fieldListApi.URL, {
        headers: o
      }).then(function (e) {
        var n = _this6.fieldListApi.labelKey || 'label',
          l = _this6.fieldListApi.nameKey || 'name',
          s = _this6.fieldListApi.resultDataName || '',
          c = s ? e.data[s] : e.data;
        _this6.fieldList.splice(0, _this6.fieldList.length), c.forEach(function (u) {
          _this6.fieldList.push({
            label: u[n],
            name: u[l]
          });
        });
      }).catch(function (e) {
        _this6.$message.error(e);
      });
    },
    initServerFields: function initServerFields() {
      var _this$fieldList, _this$subFormList;
      !!this.fieldListData && !!this.fieldListData.fieldList ? ((_this$fieldList = this.fieldList).splice.apply(_this$fieldList, [0, this.fieldList.length].concat(_toConsumableArray(this.fieldListData.fieldList))), this.fieldListData.subFormList && (_this$subFormList = this.subFormList).splice.apply(_this$subFormList, [0, this.subFormList.length].concat(_toConsumableArray(this.fieldListData.subFormList)))) : this.loadFieldListFromServer();
    },
    setFieldListData: function setFieldListData(o) {
      var _this$fieldList2, _this$subFormList2;
      !!o && !!o.fieldList && ((_this$fieldList2 = this.fieldList).splice.apply(_this$fieldList2, [0, this.fieldList.length].concat(_toConsumableArray(o.fieldList))), o.subFormList && (_this$subFormList2 = this.subFormList).splice.apply(_this$subFormList2, [0, this.subFormList.length].concat(_toConsumableArray(o.subFormList))));
    },
    handleLanguageChanged: function handleLanguageChanged(o) {
      this.changeLanguage(o), this.curLangName = this.i18nt('application.' + o);
    },
    changeLanguage: function changeLanguage(o) {
      changeLocale(o);
    },
    setFormJson: function setFormJson(o) {
      var e = !1;
      o && (typeof o == 'string' ? e = this.designer.loadFormJson(JSON.parse(o)) : o.constructor === Object && (e = this.designer.loadFormJson(o)), e && this.designer.emitHistoryChange());
    },
    getFormJson: function getFormJson() {
      return {
        widgetList: deepClone(this.designer.widgetList),
        formConfig: deepClone(this.designer.formConfig)
      };
    },
    clearDesigner: function clearDesigner() {
      this.$refs.toolbarRef.clearFormWidget();
    },
    refreshDesigner: function refreshDesigner() {
      var o = this.getFormJson();
      this.designer.clearDesigner(!0), this.designer.loadFormJson(o);
    },
    previewForm: function previewForm() {
      this.showPreviewDialogFlag = true;
    },
    importJson: function importJson() {
      this.$refs.toolbarRef.importJson();
    },
    exportJson: function exportJson() {
      this.$refs.toolbarRef.exportJson();
    },
    exportCode: function exportCode() {
      this.$refs.toolbarRef.exportCode();
    },
    generateSFC: function generateSFC() {
      this.$refs.toolbarRef.generateSFC();
    },
    getFieldWidgets: function getFieldWidgets() {
      var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return getAllFieldWidgets(o || this.designer.widgetList, e);
    },
    getContainerWidgets: function getContainerWidgets() {
      var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return getAllContainerWidgets(o || this.designer.widgetList);
    },
    upgradeFormJson: function upgradeFormJson(o) {
      var _this7 = this;
      if (!o.widgetList || !o.formConfig) {
        this.$message.error('Invalid form json!');
        return;
      }
      return traverseAllWidgets(o.widgetList, function (e) {
        _this7.designer.upgradeWidgetConfig(e);
      }), this.designer.upgradeFormConfig(o.formConfig), o;
    },
    getWidgetRef: function getWidgetRef(o) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return this.$refs.formRef.getWidgetRef(o, e);
    },
    getSelectedWidgetRef: function getSelectedWidgetRef() {
      return this.$refs.formRef.getSelectedWidgetRef();
    },
    addDataSource: function addDataSource(o) {
      this.designer.formConfig.dataSources.push(o);
    },
    addEC: function addEC(o, e) {
      this.externalComponents[o] = e;
    },
    hasEC: function hasEC(o) {
      return this.externalComponents.hasOwnProperty(o);
    },
    getEC: function getEC(o) {
      return this.externalComponents[o];
    },
    buildFormDataSchema: function buildFormDataSchema() {
      var o = {},
        e = getAllContainerWidgets(this.designer.widgetList),
        n = [],
        l = [];
      e.forEach(function ($) {
        $.type === 'sub-form' || $.type === 'grid-sub-form' ? n.push($.container) : $.type === 'object-group' && l.push($.container);
      });
      var s = [];
      n.forEach(function ($) {
        var g = {};
        traverseFieldWidgetsOfContainer($, function (y) {
          y.formItemFlag && (g[y.options.name] = y.type, s.push(y.options.name));
        }), o[$.options.name] = g;
      });
      var c = [];
      return l.forEach(function ($) {
        var g = {};
        traverseFieldWidgetsOfContainer($, function (f) {
          f.formItemFlag && (g[f.options.name] = f.type, c.push(f.options.name));
        });
        var y = $.options.objectName;
        setObjectValue(o, y, g);
      }), getAllFieldWidgets(this.designer.widgetList).forEach(function ($) {
        s.indexOf($.name) === -1 && c.indexOf($.name) === -1 && (o[$.name] = $.type);
      }), o;
    },
    getFormTemplates: function getFormTemplates() {
      return getAllFormTemplates();
    },
    clearFormTemplates: function (_clearFormTemplates) {
      function clearFormTemplates() {
        return _clearFormTemplates.apply(this, arguments);
      }
      clearFormTemplates.toString = function () {
        return _clearFormTemplates.toString();
      };
      return clearFormTemplates;
    }(function () {
      clearFormTemplates();
    }),
    addFormTemplate: function (_addFormTemplate) {
      function addFormTemplate(_x) {
        return _addFormTemplate.apply(this, arguments);
      }
      addFormTemplate.toString = function () {
        return _addFormTemplate.toString();
      };
      return addFormTemplate;
    }(function (o) {
      addFormTemplate(o), this.designer.emitEvent('refresh-form-templates');
    }),
    deleteFormTemplate: function (_deleteFormTemplate) {
      function deleteFormTemplate(_x2) {
        return _deleteFormTemplate.apply(this, arguments);
      }
      deleteFormTemplate.toString = function () {
        return _deleteFormTemplate.toString();
      };
      return deleteFormTemplate;
    }(function (o) {
      deleteFormTemplate(o), this.designer.emitEvent('refresh-form-templates');
    }),
    toggleLeftAside: function toggleLeftAside() {
      this.leftAsideVisible = !this.leftAsideVisible;
    },
    toggleRightAside: function toggleRightAside() {
      this.rightAsideVisible = !this.rightAsideVisible;
    },
    changePrimaryColor: function changePrimaryColor(o) {
      document.documentElement.style.setProperty('--el-color-primary', o), document.documentElement.style.setProperty('--vf-color-primary', o);
    },
    setMetaFields: function setMetaFields(o) {
      this.$refs.widgetPanelRef.setMetaFields(o);
    },
    setTestOptionData: function setTestOptionData(o) {
      this.optionData = o;
    },
    refreshWidgetPanel: function refreshWidgetPanel() {
      this.widgetPanelKey = 'widgetPanel' + generateId();
    }
  }
};